import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import { useAssessment } from "@/context/AssessmentContext";

export default function CTASection() {
  const { openAssessment } = useAssessment();
  return (
    <section className="relative overflow-hidden bg-navy py-24 lg:py-32" data-testid="final-cta">
      <div className="pointer-events-none absolute -left-32 top-1/2 h-96 w-96 -translate-y-1/2 rounded-full bg-ocean/25 blur-3xl" />
      <div className="pointer-events-none absolute -right-32 top-0 h-96 w-96 rounded-full bg-sky/10 blur-3xl" />
      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <span className="eyebrow text-sky">Your Property Deserves Better</span>
          <h2 className="mt-5 font-serif text-4xl font-bold leading-tight text-white text-balance sm:text-5xl lg:text-6xl">
            Your Property Deserves to Be Seen.
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-white/75">
            Whether you're launching a new property or looking to improve an existing online presence, HM Services can help you build a stronger digital hospitality strategy.
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button onClick={openAssessment} data-testid="cta-assessment" className="rounded-full bg-sky px-8 py-6 text-base font-semibold text-navy transition-transform duration-200 hover:scale-[1.03] hover:bg-sky-light">
              Get a Free Property Assessment
            </Button>
            <Button asChild variant="outline" data-testid="cta-contact" className="rounded-full border-white/30 bg-transparent px-8 py-6 text-base text-white hover:bg-white/10 hover:text-white">
              <Link to="/contact">Contact HM Services <ArrowRight className="h-4 w-4" /></Link>
            </Button>
          </div>
          <p className="mt-8 text-sm text-white/50">Let's build a stronger online presence for your hospitality business.</p>
        </Reveal>
      </div>
    </section>
  );
}
